var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMoneybag1Dark = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 158.97 150",
    style: {
      enableBackground: "new 0 0 158.97 150"
    },
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.mbd0{fill:#D4D3D7;transform-origin: 50% 50%;  transform-box: fill-box;}\n\t.mbd1{fill:#B59969;}\n\t.mbd2{fill:#9D8257;}\n\t.mbd3{fill:#4A4032;}\n\t.bag{transform-origin: 50% 100%; transform-box: fill-box;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "mbd0",
    cx: 79.49,
    cy: 135.71,
    rx: 79.49,
    ry: 14.29
  }), /*#__PURE__*/React.createElement("g", {
    className: "bag"
  }, /*#__PURE__*/React.createElement("path", {
    className: "mbd1",
    d: "M133.68,110.46c0,31.04-23.92,28.48-53.43,28.48s-53.43,2.56-53.43-28.47s33.58-83.9,53.43-83.91 C103.06,26.54,133.68,79.42,133.68,110.46z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "mbd2",
    d: "M80.25,26.55c-1.15,0.02-2.29,0.19-3.4,0.5c17.62,20.03,33.09,55.67,33.09,79.71 c0,29.59-18.3,32.15-43.07,32.22c4.28,0.01,8.76-0.05,13.39-0.05c29.51,0,53.43,2.56,53.43-28.47S103.06,26.54,80.25,26.55z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "mbd1",
    d: "M89.47,33.84H68.69L50.68,2.3C53.38-1.55,64.72,3.91,69.43,4c4.43,0.07,7.44-4,12.75-4 c4.78,0,9.11,5.11,12.38,6.27c3.06,1.08,11.16-3.97,12.93,1.17L89.47,33.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "mbd3",
    d: "M68.72,90.06l-4.02,4.26v11.06h-6.16V69.91h6.16v16.64l3.41-4.22l10.38-12.43h7.46L72.76,85.63l13.94,19.76 h-7.31L68.72,90.06z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "mbd3",
    d: "M103.22,84.44c-0.39-0.07-0.78-0.12-1.18-0.15s-0.81-0.05-1.23-0.05c-1.22-0.05-2.42,0.23-3.49,0.83 c-0.88,0.54-1.58,1.34-2,2.29v18.03H89.4V79.03h5.65l0.15,2.95c0.62-1.02,1.46-1.89,2.47-2.52c1.05-0.63,2.25-0.94,3.47-0.91 c0.39,0,0.78,0.04,1.16,0.11c0.32,0.05,0.63,0.12,0.94,0.23L103.22,84.44z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "mbd3",
    d: "M103,102.44c-0.03-0.87,0.3-1.72,0.9-2.35c1.47-1.25,3.63-1.25,5.09,0c0.6,0.63,0.93,1.48,0.9,2.35 c0.03,0.86-0.3,1.69-0.9,2.3c-0.69,0.64-1.62,0.97-2.56,0.91c-0.49,0.01-0.99-0.08-1.45-0.24c-0.41-0.15-0.78-0.38-1.08-0.68 c-0.29-0.29-0.52-0.64-0.67-1.02C103.07,103.3,103,102.88,103,102.44z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "mbd2",
    points: "64.13,50.32 71.25,32.35 72.93,33.72 77.69,33.72  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "mbd2",
    d: "M94.56,6.27c-2.67-0.95-6.05-4.52-9.8-5.8v33.38h4.71l18.02-26.41C105.72,2.3,97.62,7.35,94.56,6.27z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "mbd2",
    d: "M69.72,3.98c-0.1,0-0.19,0.01-0.29,0.01C65.6,3.93,57.39,0.3,53,1.02l18.25,29.07h-4.7l2.14,3.75h8.51 L69.72,3.98z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "mbd3",
    d: "M66.56,29.57l26.51-1.29c0.56-0.03,1.05,0.41,1.07,0.97l0.04,0.79c0.03,0.56-0.41,1.05-0.97,1.07L66.7,32.41 c-0.56,0.03-1.05-0.41-1.07-0.97l-0.04-0.79C65.56,30.08,65.99,29.6,66.56,29.57z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "mbd3",
    d: "M65.51,31.16h28.46c0.57,0,1.02,0.46,1.02,1.02v0.79c0,0.57-0.46,1.02-1.02,1.02H65.51 c-0.57,0-1.02-0.46-1.02-1.02v-0.79C64.48,31.61,64.94,31.16,65.51,31.16z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "mbd3",
    d: "M102.28,54.82c-0.15,0.63-2.06,1.92-2.24,1.29c-1.78-6.14-7.41-17.71-14.61-21.99 c-0.6-0.36,1.87-1.37,2.55-1.17C94.25,34.76,103.77,48.46,102.28,54.82z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "mbd3",
    d: "M83.43,48.33c-0.49,0.34-2.78,0.5-2.37-0.37c3.08-6.5,4.56-11.34,3.05-14.13c-0.29-0.54,2.06-0.46,2.46,0 C88.71,36.31,86.48,46.23,83.43,48.33z"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMoneybag1Dark);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/moneybag1_dark.7c9ca91ee7d254292699deaf76efd8d1.svg";